import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppState } from '~/app/contexts/app-context';
import {
	StyledNotification,
	StyledNotificationContainer,
} from '~/app/pages/components/notification/styled-notification';
import { NbaTargetTypes } from '~/app/tracking/feld-m-types';
import { Container, InnerContainer } from '~/styles/container';

export const ResponseNotification = () => {
	const { notificationData } = useAppState();
	const dispatch = useAppDispatch();
	const notificationRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			const buttonElement = notificationRef.current?.querySelector('a');
			buttonElement?.focus();
		}, 100);
		return () => clearTimeout(timeoutId);
	}, [notificationRef]);

	const closeNotification = () => {
		const nextButtonId = NbaTargetTypes.ConfigurationSave;
		dispatch({ type: 'SET_NOTIFICATION_DATA', payload: undefined });
		document.getElementById(nextButtonId)?.focus();
	};

	return (
		<>
			<StyledNotificationContainer role="alert">
				<Container>
					<InnerContainer ref={notificationRef}>
						<StyledNotification
							copy={notificationData?.copy || ''}
							icon={notificationData?.icon || 'info-circle'}
							title={{
								tag: 'h1',
								text: notificationData?.title?.text || '',
							}}
							closeButton={{
								ariaLabel: 'close',
								onClick: () => {
									closeNotification();
								},
							}}
							textLink={notificationData?.textLink}
							button={notificationData?.button}
							error={notificationData?.error}
						/>
					</InnerContainer>
				</Container>
			</StyledNotificationContainer>
		</>
	);
};
